import DNAButton from '@alucio/lux-ui/src/components/controls/DNAButton/DNAButton.theme.alucio';
import DNAText from '@alucio/lux-ui/src/components/type/DNAText/DNAText.theme.alucio';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox.theme.alucio';
import DNAChip from '@alucio/lux-ui/src/components/visual/DNAChip/DNAChip.theme.alucio';
import DNACard from '@alucio/lux-ui/src/components/layout/DNACard/DNACard.theme.alucio';
import DNAContextMenu from '@alucio/lux-ui/src/components/controls/DNAContextMenu/DNAContextMenu.theme.alucio';
import DNACheckbox from '@alucio/lux-ui/src/components/controls/DNACheckbox/DNACheckbox.theme.alucio';
import DNASelect from '@alucio/lux-ui/src/components/controls/DNASelect/DNASelect.theme.alucio';
import DNAHeader from '@alucio/lux-ui/src/components/layout/DNAHeader/DNAHeader.theme.alucio';
export default {
    strict: {
        ...DNAButton.tokens,
        ...DNAText.tokens,
        ...DNABox.tokens,
        ...DNAChip.tokens,
        ...DNACard.tokens,
        ...DNAContextMenu.tokens,
        ...DNACheckbox.tokens,
        ...DNASelect.tokens,
        ...DNAHeader.tokens,
    },
    components: {
        // Note: we're still levering some styles from the base UI Kitten (hence no DNA prefix)
        Button: DNAButton.theme,
        CheckBox: DNACheckbox.theme,
        Text: DNAText.theme,
        Select: DNASelect.theme,
        DNABox: DNABox.theme,
        DNAChip: DNAChip.theme,
        DNACard: DNACard.theme,
        DNAContextMenu: DNAContextMenu.theme,
        DNAHeader: DNAHeader.theme,
    },
};
//# sourceMappingURL=mappings.js.map